export default __webpack_public_path__ + "static/media/airCloud.b5cd3d3e.png";